import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import swal from 'sweetalert2';
import { Form } from 'react-form';
import { obtenirTokenAutorisation, journaliserConnexion } from '../../App_Code/API';
import { estVide, estEmailValide } from '../../App_Code/Utils';
import { AfficherFeedback, Texte } from '../ChampFormulaire';
// import {obtenirNavigateur} from '../../App_Code/Utils';
// import detect from '../../App_Code/Navigateur';

const GMC_URL = process.env.NODE_ENV === 'production' ? window.env.GMC_URL : process.env.REACT_APP_GMC_URL;
//PILOTE : Liste des emails pour lesquels on doit activer la MFA.
const emailsPilote = [
  "propri092026@yopmail.com"
];

function StockerTokens(token, droit) {
    sessionStorage.setItem('token', token);
    if (droit) sessionStorage.setItem('droit', droit);
    journaliserConnexion().then((response) => {
    });

}

const Lien = ({ to, children }) =>
    (window === window.top ? (
        <Link to={to}>{children}</Link>
    ) : (
        <a target="_top" href={`${window.location.origin}${to}`}>
            {children}
        </a>
    ));

class PageConnexion extends Component {
    constructor(props) {
        super(props);

        const { location } = props;
        this.emailInput = React.createRef();
        this.mdpInput = React.createRef();
        this.connexionInput = React.createRef();

        this.defaultValues = {
            email: location && location.state && location.state.email ? location.state.email : '',
        };

        this.state = {
            valide: 'true',
        };
    }

    componentDidMount() {
        document.title = 'Connexion à Gérer-ma-Copro';

        /* API qui a redirigé sur cette page en cas de connexion depuis un KELId */
        if (!this.props.location || !this.props.location.search) return;
        const { history, location } = this.props;
        const params = new URLSearchParams(location.search);

        const token = params.get('token');
        const droit = params.get('droit');
        if (!token) return;

        StockerTokens(token, droit);
        history.replace('/Chargement');
}
    handleSubmit = (submittedValues) => {
        const { email, mdp } = submittedValues;
        const { history } = this.props;
        this.connexionInput.current.disabled = true;

        const emailValide = estEmailValide(email);
        AfficherFeedback(this.emailInput, emailValide);

        const mdpValide = !estVide(mdp);
        AfficherFeedback(this.mdpInput, mdpValide);

        if (!emailValide || !mdpValide) {
            this.connexionInput.current.disabled = false;
            return;
        }

        sessionStorage.setItem('email', email);

        obtenirTokenAutorisation(email, mdp).then((token) => {
  
            if (token && typeof token == 'string') {
                /* Connecté en tant qu'agence/Kel */
                if (token == 'Maintenance') {
                    history.push('/Maintenance');
                }else if( token == 'Reinit')
                {
                    this.setState({ valide: 'Votre mot de passe est expiré, merci d\'utiliser la procédure \'Mot de passe oublié\' pour en créer un nouveau' })
                 this.connexionInput.current.disabled = false;
                }else {
                    
                    window.top.location.href = `${GMC_URL}?KELId=${token}`;
                }
            } else if (token && typeof token === 'object') {
                /* Connecté en tant que propriétaire */

                StockerTokens(token[0], token[1]);
                 if (window === window.top && emailsPilote.includes(email)) {
             //       history.push('/MFA', { kelId: token });
                    // history.push('/Chargement');
  window.top.location.href = `${window.location.origin}/Chargement`;
                 } else {
                    
                    //  window.top.location.href = `${window.location.origin}/MFA?kelId=${token}`;
                     window.top.location.href = `${window.location.origin}/Chargement`;
             }
            } else {
                /* Erreur */
                if (typeof token !== 'undefined') this.setState({ valide: 'E-mail ou mot de passe incorrect'  });
                this.connexionInput.current.disabled = false;
            }
        });
    };

    render() {
        const { valide } = this.state;

        return (
            <Form defaultValues={this.defaultValues} onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <div className="form-group required">
                            <label htmlFor="LoginEmail">E-mail</label>
                            <Texte
                                id="LoginEmail"
                                field="email"
                                placeholder="E-mail"
                                type="email"
                                refRef={this.emailInput}
                            />
                            <div className="invalid-feedback">Veuillez renseigner votre e-mail</div>
                        </div>

                        <div className="form-group required">
                            <label htmlFor="LoginPassword">Mot de passe</label>
                            <Texte
                                id="LoginPassword"
                                field="mdp"
                                placeholder="Mot de passe"
                                type="password"
                                refRef={this.mdpInput}
                            />
                            <div className="invalid-feedback">Veuillez renseigner votre mot de passe</div>
                        </div>
                        <div className="d-flex flex-row-reverse">
                            <Lien to="/MotdepasseOublie">Mot de passe oublié ?</Lien>
                        </div>
                        {valide != 'true' && (
                            <div className="text-center text-danger mb-3">
                                <i className="fas fa-exclamation-circle" /> {valide}
                            </div>
                        )}
                        <button
                            type="submit"
                            className="btn btn-block btn-lg btn-success mt-3"
                            ref={this.connexionInput}
                        >
                            Connexion
                        </button>
                        <div className="inscription">
                            Vous n&#39;avez pas encore de compte ?&nbsp;
                            <Lien to="/Inscription">Inscription</Lien>
                        </div>
                    </form>
                )}
            </Form>
        );
    }
}
PageConnexion.displayName = 'PageConnexion';

export default PageConnexion;



// WEBPACK FOOTER //
// ./src/components/Adherent/PageConnexion.js